import FilterItem from './FilterItem';
export class GenericFilter {
    tags;
    constructor(response) {
        if (response?.tags?.values !== undefined && response.tags.values.length > 0) {
            this.tags = new FilterItem(response.tags);
        }
    }
}
